<!-- <div>
    <div class="content-container">
        <mat-icon id="close-icon" (click)="closeDialog()">close</mat-icon>
        <span class="content-span full-width">{{data.message}}</span>
    </div>
    <button mat-flat-button id="no-button" [mat-dialog-close]="false">NO</button>
    <button mat-flat-button id="yes-button" [mat-dialog-close]="true">YES</button>
</div> -->




<mat-toolbar class="toolbar-example">  
    <mat-icon id="close-icon" (click)="closeDialog()">close</mat-icon>
</mat-toolbar>
<div class="confirm-dialog-body">
    <p style="text-align: center;">{{data.message}}</p>
</div>
<div class="actions-example">
    <button mat-raised-button class="btn-cancel" [mat-dialog-close]="false">NO</button>  <!--id="no-button"-->
    <button mat-raised-button class="btn-color-example" style="margin-left: 10px;" [mat-dialog-close]="true">YES</button> <!--id="yes-button"-->
</div>

